import { StarOutlined, StarFilled } from "@ant-design/icons";
import { SvgIconProps } from "./SvgIcon";

export const FavoriteIcon = (props: SvgIconProps & { filled?: boolean }) => {
  const Icon = props.filled ? StarFilled : StarOutlined;
  return (
    <Icon
      style={{
        ...props.style,
        fontSize: typeof props.size === "number" ? props.size : 14,
        ...(props.disabled ? { opacity: 0.3 } : {}),
      }}
    />
  );
};
